const config = {
  API_URL: '/api'
}

export default config
